class ShowMore extends HTMLElement {
  constructor() {
    super();
    this.icon = this.querySelector("span");
    this.addEventListener("click", this.expanded.bind(this));
  }

  expanded(event) {
    event.preventDefault();
    const toggleButton = event.currentTarget.querySelector("button");
    const siblingElement = event.currentTarget.previousElementSibling;
    siblingElement.classList.toggle("expanded");
    this.icon.classList.toggle("expanded");

    if (siblingElement.classList.contains("expanded")) {
      toggleButton.textContent = this.dataset.showLess;
    } else {
      toggleButton.textContent = this.dataset.showMore;
    }
  }
}

if (!customElements.get("show-more")) {
  customElements.define("show-more", ShowMore);
}

class DetailsSummary extends HTMLElement {
  constructor() {
    super();
    this.details = this.querySelector("details");
    this.summary = this.querySelector("summary");
    this.content = this.querySelector(".accordion__content");
    this.isSubAccordion = this.details.classList.contains("subaccordion");
    this.parentAccordion = this.closest("details-summary:not(:scope)");

    this.init();
    this.summary.addEventListener("click", this.toggleOpen.bind(this));
    this.summary.parentElement.addEventListener(
      "keyup",
      this.onKeyUpEscape.bind(this)
    );
    this.content.addEventListener(
      "transitionend",
      this.onTransitionEnd.bind(this)
    );
  }

  init() {
    this.summary.setAttribute("role", "button");
    this.summary.setAttribute(
      "aria-expanded",
      this.details.hasAttribute("open")
    );

    if (this.content.getAttribute("id")) {
      this.summary.setAttribute("aria-controls", this.content.id);
    }

    if(this.details.hasAttribute("open")) {
      this.openAccordion()
    } else {
      this.closeAccordion(this)
    }
  }

  onKeyUpEscape(event) {
    if (event.code.toUpperCase() !== "ESCAPE") return;

    const openDetailsElement = event.target.closest("details[open]");
    if (!openDetailsElement) return;

    const summaryElement = openDetailsElement.querySelector("summary");
    this.closeAccordion(openDetailsElement);
    summaryElement.focus();
  }

  updateParentHeight(child, isOpen) {
    const childHeight = child.scrollHeight;

    if (this.parentAccordion) {
      const parentContent = this.parentAccordion.querySelector(
        ".accordion__content"
      );
      if (parentContent) {
        setTimeout(() => {
          if (isOpen) {
            parentContent.style.maxHeight =
              parentContent.scrollHeight + childHeight + "px";
          } else {
            parentContent.style.maxHeight =
              parentContent.scrollHeight - childHeight + "px";
          }
        }, 50);
      }
    }
  }

  toggleOpen(event) {
    event.preventDefault();

    const isOpening = !this.details.hasAttribute("open");
    this.summary.setAttribute("aria-expanded", isOpening);

    if (isOpening) {
      this.openAccordion();
    } else {
      this.closeAccordion(this.details);
    }
  }

  openAccordion() {
    this.details.setAttribute("open", "");
    requestAnimationFrame(() => {
      const height = this.content.scrollHeight;
      this.content.style.maxHeight = height + "px";
      this.updateParentHeight(this.content, true);
    });
  }

  closeAccordion(details) {
    const nestedOpenAccordions = details.querySelectorAll("details[open]");
    nestedOpenAccordions.forEach((nested) => {
      const nestedContent = nested.querySelector(".accordion__content");
      if (nestedContent) {
        nestedContent.style.maxHeight = "0px";
      }
      const nestedSummary = nested.querySelector("summary");
      if (nestedSummary) {
        nestedSummary.setAttribute("aria-expanded", "false");
      }
    });
    this.updateParentHeight(this.content, false);
    this.content.style.maxHeight = "0px";
    this.content.addEventListener(
      "transitionend",
      () => {
        details.removeAttribute("open");
        nestedOpenAccordions.forEach((nested) => {
          nested.removeAttribute("open");
        });
      },
      { once: true }
    );
  }

  onTransitionEnd(event) {
    if (event.target !== this.content) return;

    if (!this.details.hasAttribute("open")) {
      this.content.style.maxHeight = "";
    }
  }
}

if (!customElements.get("details-summary")) {
  customElements.define("details-summary", DetailsSummary);
}

class EstimatedDelivery extends HTMLElement {
  constructor() {
    super();
  }
  connectedCallback() {
    const today = new Date();
    const options = JSON.parse(this.getAttribute("options"));
    const locale = Intl.DateTimeFormat().resolvedOptions().locale || "en-US";
    const regex = /date_plus_(\d+)/g;

    this.innerHTML = this.innerHTML.replace(regex, (match, days) => {
      const businessDays = parseInt(days, 10);
      const futureDate = this.addBusinessDays(today, businessDays);
      return futureDate.toLocaleDateString(locale, options);
    });
  }

  addBusinessDays(startDate, daysToAdd) {
    let currentDate = new Date(startDate);
    let daysAdded = 0;

    while (daysAdded < daysToAdd) {
      currentDate.setDate(currentDate.getDate() + 1);
      let dayOfWeek = currentDate.getDay();
      if (dayOfWeek !== 0 && dayOfWeek !== 6) {
        daysAdded++;
      }
    }
    return currentDate;
  }
}

customElements.define("estimated-delivery", EstimatedDelivery);

function getElementHeight(element) {
  const height = getComputedStyle(element).getPropertyValue("height");
  return parseFloat(height);
}

const titleContainers = document.querySelectorAll(
  ".product-grid"
);
titleContainers.forEach((container) => {
  const productTitles = container.querySelectorAll(
    ".card__information .card__heading"
  );
  let maxHeight = 24;

  productTitles.forEach((element) => {
    try {
      const height = getElementHeight(element);

      if (height > maxHeight) {
        maxHeight = height;
      }
    } catch (error) {
      console.error("Error getting height for element:", error.message);
    }
  });

  container.style.setProperty("--max-lines", maxHeight + "px");
});


class CartRecommendations extends HTMLElement {
  constructor() {
    super();
    this.modalOptions = this.querySelectorAll('.cart-recommended__options');
    this.confirmBtns = this.querySelectorAll('[data-confirm]');
    this.closeBtns = this.querySelectorAll('.cart-modal__close');
    
    this.addToCartBtns = this.querySelectorAll('[data-button]');
    this.addToCartBtns.forEach(btn => btn.addEventListener('click', this.onClick.bind(this)))

    this.confirmBtns.forEach(btn => btn.addEventListener('click', this.onConfirm.bind(this)))
    this.closeBtns.forEach(btn => btn.addEventListener('click', this.closeModal.bind(this)))
  }

  onClick(event) {
    event.preventDefault();
    const productId = event.target.dataset.button;
    this.openModal(productId);
  }

  openModal(id) {
   this.modalOption = this.querySelector(`.cart-recommended__options[data-recommended='${id}']`);
    this.select = this.modalOption?.querySelector('select');

    this.select?.addEventListener('change', this.onChange.bind(this));
    this.modalOption.classList.remove('hidden')    
  }

  closeModal() {
    this.modalOptions.forEach(modal => modal.classList.add('hidden'))
  }

  onChange(event){
    const variantId = event.target.value;
    const formId = event.target.dataset.form;
    const form = this.querySelector(`[id='${formId}']`);
    form.querySelector('[name="id"]').value = variantId;
  }
  
  onConfirm(event){
    event.preventDefault();
    const confirmId = event.target.dataset.confirm;

    this.closeModal()
  }
}

if (!customElements.get("cart-recommendations")) {
  customElements.define("cart-recommendations", CartRecommendations);
}

  class CustomLink extends HTMLElement {
    constructor() {
      super();
      this.addEventListener('click', this.onRoute.bind(this));
    }

    onRoute(event) {
      event.preventDefault();

      const url = this.getAttribute('href');
      const target = this.getAttribute('target');

      if (url) {
        if (target === '_blank') {
          window.open(url, '_blank', 'noopener,noreferrer'); 
        } else {
          window.location.href = url; // Opens in the same tab
        }
      }
    }
  }

  if (!customElements.get("custom-link")) {
    customElements.define("custom-link", CustomLink);
  }

const judgeme = document.querySelector('.jdgm-carousel');
if(judgeme) {
  const judgemeImages = judgeme.querySelectorAll('.jdgm-carousel-item__product-image');
  const judgemeLinks = judgeme.querySelectorAll('a.jdgm-carousel-item__product.jdgm-ellipsis'); 
  judgemeImages.forEach(img => {
    img.width = 100;  
    img.height = 100; 
  });
  
  judgemeLinks.forEach((link, index) => {
    link.ariaLabel = `Read more about testimonial ${index + 1}`
  })
}





